import { BackednResponse } from "@shared/lib/types";
import {
  IBriefLedgerSearchRequest,
  IGetBriefLedgers,
} from "@shared/lib/types/briefLedger";
import { useQuery } from "@tanstack/react-query";
import { BriefService } from "../services/brief.service";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";
import { BRIEF_LEDGER_QUERY_KEY } from "../constants";

export function useGetBriefLedgers(params: IBriefLedgerSearchRequest) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IGetBriefLedgers>
  >({
    queryKey: [...BRIEF_LEDGER_QUERY_KEY, params],
    queryFn: () => BriefService.getBriefLedgers(params),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    ledgers: data?.data?.data || [],
    totalCount: data?.data?.pagination.totalCount || 0,
    isFetching: isLoading,
    isError,
  };
}
